/**
 * 文件说明:
 *
 * hz Sider Menu component
 *
 * ----------------------------------------
 * 创建用户: leo
 */

import {memo} from 'react'
import {Layout, Spin} from 'antd'
import BaseMenu from '../base-meun'
import styles from './index.less'

const {Sider} = Layout

const SiderMenu = memo((props) => {
    const {loading = false, menuData, flatMenuData, pathname, siderWidth = 160} = props

    return (
        <Sider width={siderWidth}>
            {loading ? (
                <div className={styles.loadingWarp}>
                    <Spin className={styles.loading} />
                </div>
            ) : (
                <BaseMenu
                    menuData={menuData}
                    flatMenuData={flatMenuData}
                    className={styles.menu}
                    pathname={pathname}
                />
            )}
        </Sider>
    )
})

export default SiderMenu
